export default function debounce(callback, wait) {
    let debounceTimer;

    return function debounced(...args) {
        const delayedFunction = () => {
            debounceTimer = null;
            callback.apply(this, args);
        };

        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }

        debounceTimer = setTimeout(delayedFunction, wait ?? 300);
    };
}
